const BASE = '/drivinglife'

export const LOG = {
  MAIN: {
    PAGE_ID: `${BASE}/main`,
  },
  MAIN_NEWCOMER: {
    PAGE_ID: `${BASE}/main_newcomer`,
  },
  MAIN_INTRO: {
    PAGE_ID: `${BASE}/intro`,
  },
  APP_UPDATE: {
    PAGE_ID: `${BASE}/main/popup_appupdate`,
  },
  TERMS: {
    PAGE_ID: `${BASE}/terms`,
  },
  TERMS_TM: {
    PAGE_ID: `${BASE}/terms_tele-marketing`,
  },
  TERMS_REGISTER_VEHICLE: {
    PAGE_ID: `${BASE}/carRegistration`,
  },
  BENEFIT: {
    PAGE_ID: `${BASE}/benefit`,
  },
  BENEFIT_POINT: {
    PAGE_ID: `${BASE}/benefit_point`,
  },
  BENEFIT_POPULAR: {
    PAGE_ID: `${BASE}/selected_benefits`,
  },
  BENEFIT_REMINDER: {
    PAGE_ID: `${BASE}/bottomsheet_benefit_reminder`,
  },
  BENEFIT_INSURANCE_VEHICLE_DETAIL: {
    PAGE_ID: `${BASE}/insur_vehicle_detail`,
  },
  DRIVING_ANALYSIS: {
    PAGE_ID: `${BASE}/analysis`,
  },
  DRIVING_ANALYSIS_PLACE: {
    PAGE_ID: `${BASE}/analysis/category_detail`,
  },
  DRIVING_HISTORY: {
    PAGE_ID: `${BASE}/record`,
  },
  DRIVING_HISTORY_DETAIL: {
    PAGE_ID: `${BASE}/record/history`,
  },
  VEHICLE: {
    PAGE_ID: `${BASE}/mycar`,
  },
  VEHICLE_NOT_REGISTERED: {
    PAGE_ID: `${BASE}/mycar_not_registered`,
  },
  VEHICLE_SETTING: {
    PAGE_ID: `${BASE}/mycar/carChange`,
  },
  VEHICLE_HIGHWAYTOLL_TERMS: {
    PAGE_ID: `${BASE}/mycar/highwaytoll_terms`,
  },
  INSURANCE_TAB: {
    PAGE_ID: `${BASE}/analysis_benefit_tab`,
  },
  BENEFIT_HOME: {
    PAGE_ID: `${BASE}/insurance_benefits`,
  },
  BENEFIT_HOME_HALL: {
    PAGE_ID: `${BASE}/insurance_benefits/hall`,
  },
  BENEFIT_HOME_INTRO: {
    PAGE_ID: `${BASE}/insurance_benefits/intro`,
  },
  ETC_INSURER_CALL: {
    PAGE_ID: `${BASE}/mycar/insurcall`,
  },
  ETC_INSURER_CALL_LIST: {
    PAGE_ID: `${BASE}/mycar/insurcall/callList`,
  },
  SETTINGS: {
    PAGE_ID: `${BASE}/setting`,
  },
  SETTINGS_OTP: {
    PAGE_ID: `${BASE}/otp`,
  },
  SETTINGS_WITHDRAWAL: {
    PAGE_ID: `${BASE}/account_withdrawal`,
  },
  UNPAID_TOLL_HISTORY: {
    PAGE_ID: `${BASE}/mycar/highwaytoll`,
  },
  UNPAID_TOLL_RESULT: {
    PAGE_ID: `${BASE}/mycar/highwaytoll/result`,
  },
  POINT_REWARD_SUCCESS: {
    PAGE_ID: `${BASE}/get_point`,
  },
  POINT_REWARD_FINISHED: {
    PAGE_ID: `${BASE}/point_finished`,
  },
  POINT_REWARD_DUPLICATED: {
    PAGE_ID: `${BASE}/point_duplicated`,
  },
  DRIVER_CARE: {
    PAGE_ID: `${BASE}/driver_care`,
  },
  DRIVER_CARE_TERMS: {
    PAGE_ID: `${BASE}/driver_care/agreementTerms`,
  },
  DRIVER_CARE_RESULT_SUCCEED: {
    PAGE_ID: `${BASE}/driver_care/result_succeed`,
  },
  DRIVER_CARE_RESULT_FAIL: {
    PAGE_ID: `${BASE}/driver_care/result_fail`,
  },
  DRIVER_CARE_HISTORY: {
    PAGE_ID: `${BASE}/driver_care/usage`,
  },
  DRIVER_CARE_HISTORY_DETAIL: {
    PAGE_ID: `${BASE}/driver_care/usage/history`,
  },
  LICENSE_PENALTY: {
    PAGE_ID: `${BASE}/penalty`,
  },
  LICENSE_PENALTY_TERMS: {
    PAGE_ID: `${BASE}/penalty/select_agree`,
  },
  LICENSE_PENALTY_INPUT: {
    PAGE_ID: `${BASE}/penalty/license`,
  },
  LICENSE_PENALTY_RESULT: {
    PAGE_ID: `${BASE}/penalty/check`,
  },
}
